import { Box, Button, Center, HStack, Icon, Stack } from "@chakra-ui/react";
import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
// import SwitchCheckbox from "../../GlobalComponents/SwitchCheckbox";

export const RBCToolbar = (props) => {
    // used to set green border bar
    const [viewState, setViewState] = useState("month");
    const [currentFormattedDate, setCurrentFormattedDate] = useState("")

    React.useEffect(() => {
        setViewState(props.view);
    }, [props.view])

    const getCustomToolbar = () => {
        // const toolbarDate = props.date;
        const goToDayView = () => {
            props.onView("day");
            setViewState("day");
        };
        const goToWeekView = () => {
            setCurrentFormattedDate(props.date.label + props.date.getFullYear())

            props.onView("week");
            setViewState("week");
        };
        const goToMonthView = () => {
            setCurrentFormattedDate(new Date(props.date).getMonth())
            props.onView("month");
            setViewState("month");
        };
        const goToAgendaView = () => {
            const newDate = new Date(props.date.getFullYear(), props.date.getMonth(), 1);
            props.onView("agenda");
            const currentDate = props.date;
            props.date.setMonth(currentDate.getMonth());
            props.date.setYear(currentDate.getFullYear());
            props.date.setDate(1);
            setViewState("agenda");
        };
        const goToBack = () => {
            let view = viewState;
            let mDate = props.date;
            let newDate;
            if (view === "month" || view === "agenda") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 7,
                    1
                );
            } else {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 1,
                    1
                );
            }
            props.onNavigate("prev", newDate);
        };
        const goToNext = () => {
            let view = viewState;
            let mDate = props.date;
            let newDate;
            if (view === "month" || view === "agenda") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 7,
                    1
                );
            } else {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 1,
                    1
                );
            }
            props.onNavigate("next", newDate);
        };

        const goToToday = () => {
            const now = new Date();
            props.date.setMonth(now.getMonth());
            props.date.setYear(now.getFullYear());
            props.date.setDate(now.getDate());
            props.onNavigate("current");
        };


        const dateFormatDisplay = () => {
            const date = new Date(props.date);
            const options = {
                year: 'numeric', month: 'long', day: 'numeric'
            };
            let formattedDate = date.toLocaleString('en-US', options);
            if (viewState === "agenda") formattedDate = "Agenda for " + date.toLocaleString('en-US', { month: 'long' })
            if (viewState === "month") formattedDate = date.toLocaleString('en-US', { month: 'long', year: 'numeric' })

            return (
                <span className="rbc-toolbar-label rbc-date">
                    <i className="far fa-calendar"></i> <span>{`${formattedDate}`}</span>
                </span>
            );
        };


        const day = () => {
            let view = viewState;
            const date = new Date(props.date);
            let day;
            if (view === "day") {
                day = date.getDay();
            }
            return <span className="rbc-toolbar-label">{day}</span>;
        };

        return (
            <Center>
                <Box >
                    <HStack mr="2" justifyContent="center">
                        <Button borderRadius="0" bg="white" onClick={goToBack}>
                            <Icon as={FiChevronLeft} />
                        </Button>
                        <Box >
                            {dateFormatDisplay()}                       </Box>
                        <Button borderRadius="0" bg="white" onClick={goToNext}>
                            <Icon as={FiChevronRight} />
                        </Button>

                    </HStack>
                    {/* <Box hidden>{month()}</Box> */}
                    <HStack >
                        <Box cursor="pointer" _hover={{ bg: "green.500", color: "white" }} borderRadius="0" width="70px" textAlign="center" borderColor="green.500" borderBottomWidth={viewState === "month" ? "3px" : "0"} onClick={goToMonthView}>
                            Month
                        </Box>
                        <Box cursor="pointer" _hover={{ bg: "green.500", color: "white" }} borderRadius="0" width="70px" textAlign="center" borderColor="green.500" borderBottomWidth={viewState === "day" ? "3px" : "0"} onClick={goToDayView}>
                            Day
                        </Box>
                        <Box display={{ base: 'none', md: 'block' }} cursor="pointer" _hover={{ bg: "green.500", color: "white" }} borderRadius="0" width="70px" textAlign="center" borderColor="green.500" borderBottomWidth={viewState === "week" ? "3px" : "0"} onClick={goToWeekView}>
                            Week
                        </Box>
                        <Box cursor="pointer" _hover={{ bg: "green.500", color: "white" }} borderRadius="0" width="70px" textAlign="center" borderColor="green.500" borderBottomWidth={viewState === "agenda" ? "3px" : "0"} onClick={goToAgendaView}>
                            Agenda
                        </Box>
                    </HStack>
                </Box>
            </Center>
        );
    };

    return <>{getCustomToolbar()}</>;
}
